import type { URLOpenListenerEvent } from "@capacitor/app";
import { App } from "@capacitor/app";
import { Blac } from "blac-next";
import type { FC } from "react";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getAppPathFromUrl } from "src/hybrid/components/appUrlPath";
import reportErrorSentry from "src/lib/reportErrorSentry";
import AppViewCubit from "src/state/AppViewCubit/AppViewCubit";
import { historyState } from "src/state/state";

const AppUrlListener: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    App.addListener("appUrlOpen", (event: URLOpenListenerEvent) => {
      const appPath = getAppPathFromUrl(event.url);
      if (appPath) {
        navigate(appPath);
      }
    }).catch((err: unknown) => {
      reportErrorSentry(err);
    });
  }, []);

  useEffect(() => {
    historyState.locationChange(location);
    const appViewState = Blac.getBloc(AppViewCubit);
    appViewState.navigate = navigate;
  }, [location]);

  return null;
};

export default AppUrlListener;
